'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $stateParams, $state, $scope, toaster, Upload) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$scope = $scope;
    this.toaster = toaster;
    this.Upload = Upload;
  }

  $onInit() {
    this.getBookList();

    this.$scope.$watch('BListEditCtrl.file', (file) => {
      if (file !== undefined && file !== null) {
        this.uploadCover(file);
      }
    });
  }

  getBookList() {
    this.$http.get(`/api/booklists/${this.$stateParams.id}`).then(res => {
      this.booklist = res.data.data;
    })
  }

  save() {
    this.$http.put(`/api/booklists/${this.$stateParams.id}`, this.booklist).then(res => {
      this.$state.go('^');
    })
  }

  uploadCover(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在上传封面，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: `/api/booklists/${this.booklist._id}/uploadCover`,
      file: file,
      data: this.booklist,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.getBookList();
      this.toaster.pop('success', '上传成功', file.name);
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '上传失败', JSON.stringify(err));
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/booklist/edit/edit.controller.js